export default (blazy, wow) => {
  var node = document.createElement('style')
  node.innerHTML = '[data-showhide]{display:flex;}'
  document.querySelector('head').appendChild(node)
  var filters = document.querySelectorAll('[data-filter]')
  var search = document.querySelector('[name="search"]')
  function update (e) {
    if (e && e.target && e.target.type === 'checkbox') {
      if (e.target.checked) {
        e.target.parentNode.classList.add('checked')
      } else {
        e.target.parentNode.classList.remove('checked')
      }
    }
    var selector = ''
    Array.prototype.forEach.call(filters, function (sel) {
      if (sel.value === 'true' && sel.checked) {
        selector += '[data-' + sel.dataset.filter + '*="' + sel.value + '"]'
      } else if (sel.checked) {
        selector += '[data-' + sel.name + '*="' + sel.value + '"]'
      }
    })
    selector += '[data-search' + (search.value ? '*="' + search.value.toLowerCase() + '"' : '') + ']'
    node.innerHTML = selector + '{display:flex;}'
    blazy.revalidate()
    wow.scrollHandler()
  }
  Array.prototype.forEach.call(document.querySelectorAll('[data-filter], [name="search"]'), function (sel) {
    sel.addEventListener('change', update)
    sel.addEventListener('input', update)
  })
  if (document.querySelectorAll('[data-filter], [name="search"]').length > 1) {
    update()
  }
}
